import type { PrimitiveAtom } from 'jotai';
import { atom, type createStore } from 'jotai/vanilla';

export type HostedBadgeValue = {
	value: string;
	startYear: number | null;
};

export const hostedBadgeAtom: PrimitiveAtom<HostedBadgeValue | null> =
	atom<HostedBadgeValue | null>(null);

const normalizeStartYear = (startYear: unknown): number | null => {
	return typeof startYear === 'number' && Number.isFinite(startYear)
		? startYear
		: null;
};

const normalizeHostedBadge = (
	hostedBadge: unknown,
	startYear: unknown,
): HostedBadgeValue | null => {
	if (
		hostedBadge &&
		typeof hostedBadge === 'object' &&
		'value' in hostedBadge &&
		typeof hostedBadge.value === 'string'
	) {
		if (hostedBadge.value === '<10') {
			return null;
		}

		return {
			value: hostedBadge.value,
			startYear: normalizeStartYear(startYear),
		};
	}

	return null;
};

export const setHostedBadgeData = (
	store: ReturnType<typeof createStore>,
	storefrontData: { hostedBadge?: unknown; startYear?: unknown },
): void => {
	store.set(
		hostedBadgeAtom,
		normalizeHostedBadge(storefrontData.hostedBadge, storefrontData.startYear),
	);
};

export const getHostedBadgeDataToHydrate = (
	store: ReturnType<typeof createStore>,
): { hostedBadge: HostedBadgeValue | null } => {
	return {
		hostedBadge: store.get(hostedBadgeAtom),
	};
};

export const getHostedBadgeInitialValues = (
	data: ReturnType<typeof getHostedBadgeDataToHydrate>,
): Array<[typeof hostedBadgeAtom, HostedBadgeValue | null]> => {
	return [[hostedBadgeAtom, data?.hostedBadge ?? null]];
};
